import { ChartOptions } from 'chart.js';

const defaultOptions = (maxValueY: number): ChartOptions<'line'> => ({
  responsive: true,
  maintainAspectRatio: false,
  indexAxis: 'x',
  layout: {
    padding: {
      right: 13,
      left: 10,
      top: 10,
      bottom: 10
    }
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: true,
      mode: 'index',
      displayColors: false,
      intersect: false,
      callbacks: {
        label: function (context: any) {
          let label = context.dataset.label || '';
          if (label) {
            label += ': ';
          }
          if (context.parsed.y !== null) {
            label += new Intl.NumberFormat('sv-SE', {}).format(
              context.parsed.y
            );
          }
          return label;
        },
      },
    },
    datalabels: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      offset: true,
      ticks: {
        maxRotation: 45,
        minRotation: 0,
        autoSkip: true,
        autoSkipPadding: 10
      }
    },
    y: {
      suggestedMax: maxValueY,
      beginAtZero: true,
      grid: {
        display: true,
        color: 'rgb(30 41 59 / 5%)',
      },
    },
  },
});

export default defaultOptions;
